import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ dark = false, className = "", height = "h-11" }) {
  const img = (
    <img
      src="/hea-logo.webp"
      alt="Homeschool Enrichment Academy"
      className={`${height} w-auto object-contain`}
    />
  );
  return (
    <Link to="/" className={`inline-flex items-center ${className}`} data-testid="hea-logo">
      {dark ? (
        <span className="inline-flex items-center rounded-lg bg-white px-3 py-1.5">{img}</span>
      ) : (
        img
      )}
    </Link>
  );
}
